import React from "react";
import error from "../../images/error.jpg";
const NotFound = () => {
  return (
    <div>
      <img src={error} alt="" />
    </div>
  );
};

export default NotFound;
